<template>
  <div class="registration-wrapper">
    <div class="registration-container">
      <flash-message
        transition-name="flash"
        class="alert flashpool"
      />
      <ProgressStepper v-if="showStepper" />
      <div class="registration-panel">
        <div class="registration-form">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProgressStepper from '../components/ProgressStepper.vue';

export default {
  components: {
    ProgressStepper,
  },
  props: {
    showStepper: {
      type:     Boolean,
      default:  true,
      required: false,
    },
  },
  methods: {
    async focusFirstError() {
      await this.$nextTick();
      const errors = Array.from(this.$el.getElementsByClassName('error'));
      const firstError = errors.find((el) => el.tagName !== 'LABEL');
      if (firstError) {
        firstError.focus();
      }
    },
  },
};
</script>
<style lang="scss" module>
@import "./../lib/analytics/analytics.css";

.registration-wrapper {
  h2 {
    font-size: 2rem;
  }

  .alert {
    padding-top: 0;
    width: 100%;
    max-width: 710px;
    display: block;
    margin: 1em auto;
    @media (min-width: 768px) {
      width: auto;
    }
  }

  .flash__message {
    font-size: 16px;
    text-align: center;
    padding: 15px 50px 15px 15px;
  }

  .flash__message ul {
    list-style: none;
  }

  .flash__message a {
    position: relative;
    z-index: 10;
  }

  .flash__close-button {
    width: 100%;
    height: 100%;
    font-size: 1.25em;
    text-align: right;

    span {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 1.25em;
      color: black;
      text-decoration: none;
      cursor: pointer;
      opacity: 0.3;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>
